import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomersService } from '../../../customers/customers.service';
import { Customer } from '../../../shared/models/customer.model';

@Component({
  selector: 'exa-utility-bills-create-pg',
  templateUrl: './utility-bills-create-pg.component.html',
  styleUrls: ['./utility-bills-create-pg.component.scss']
})
export class UtilityBillsCreatePgComponent implements OnInit {

  customer$: Observable<Customer>;

  constructor(private customerSvc: CustomersService) { }

  ngOnInit() {
    this.customer$ = this.customerSvc.selected$;
  }

}
